import React from 'react';
import {noop} from 'lodash';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ALL_COACHES} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import withRecordPopover from '../withRecordPopover';

import {AllGen0CoachesContent} from './AllGen0CoachesContent';
import {AllGen0CoachesContentProps} from './AllGen0CoachesContent.types';
import reportPayload from './reportPayload';

interface Props extends Partial<AllGen0CoachesContentProps> {
  tt: (key: string, defaultValue?: string) => string;
  showRecordPopover: () => void;
  licenseExpiresOn: string;
}

export const AllGen0CoachesReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = noop,
}: Props) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'All Generation 0 Coaches')}
      description={tt(
        'description',
        'All of your Generation Zero Coaches (all of the Coaches on your team, personally sponsored by you or in depth).',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={AllGen0CoachesContent}
    />
  );
};

export default withHOC(
  withTranslation('report.AllGen0Coaches'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ALL_COACHES,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts(
          'reportRecordTitle.allGen0',
          'All Generation 0 Coaches',
        ),
    },
  }),
)(AllGen0CoachesReport);
